"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apiParamsToQueryObject = exports.mergeFilters = exports.parseQueryString = void 0;

// from https://github.com/sindresorhus/query-string/blob/master/index.js
var parseQueryString = function parseQueryString(str) {
  // Create an object with no prototype
  // https://github.com/sindresorhus/query-string/issues/47
  var ret = Object.create(null);

  if (typeof str !== 'string') {
    return ret;
  }

  str = str.trim().replace(/^(\?|#|&)/, '');

  if (!str) {
    return ret;
  }

  str.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, '+').split('='); // Firefox (pre 40) decodes `%3D` to `=`
    // https://github.com/sindresorhus/query-string/pull/37

    var key = parts.shift();
    var val = parts.length > 0 ? parts.join('=') : undefined;
    key = decodeURIComponent(key); // missing `=` should be `null`:
    // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters

    try {
      val = val === undefined ? null : decodeURIComponent(val);
    } catch (error) {
      val = null;
    }

    if (ret[key] === undefined) {
      ret[key] = val;
    } else if (Array.isArray(ret[key])) {
      ret[key].push(val);
    } else {
      ret[key] = [ret[key], val];
    }
  });
  return ret;
};

exports.parseQueryString = parseQueryString;

var mergeFilters = function mergeFilters(seo_filters, qs_filters) {
  var params = Object.assign({}, seo_filters, qs_filters);

  if (params.portal_immotype_group && !Array.isArray(params.portal_immotype_group)) {
    params.portal_immotype_group = [params.portal_immotype_group];
  }

  return params;
};

exports.mergeFilters = mergeFilters;

var apiParamsToQueryObject = function apiParamsToQueryObject(filters) {
  var ret = {};
  var ptypes = [];

  if (filters['transaction.type']) {
    ret.tr = filters['transaction.type'];
  }

  if (filters['property.types']) {
    ret.propertyTypes = filters['property.types'].map(function (p) {
      return p.slug;
    });
  }

  if (filters.price) {
    if (filters.price.gte) {
      ret.priceMin = filters.price.gte;
    }

    if (filters.price.lte) {
      ret.priceMax = filters.price.lte;
    }
  }

  if (filters.mqprice) {
    if (filters.mqprice.gte) {
      ret.mqpriceMin = filters.mqprice.gte;
    }

    if (filters.mqprice.lte) {
      ret.mqpriceMax = filters.mqprice.lte;
    }
  }

  if (filters.payment) {
    if (filters.payment.gte) {
      ret.paymentMin = filters.payment.gte;
    }

    if (filters.payment.lte) {
      ret.paymentMax = filters.payment.lte;
    }
  }

  if (filters.buildingYearRange) {
    if (filters.buildingYearRange.gte) {
      ret.buildingYearRangeMin = filters.buildingYearRange.gte;
    }

    if (filters.buildingYearRange.lte) {
      ret.buildingYearRangeMax = filters.buildingYearRange.lte;
    }
  }

  if (filters.rooms) {
    if (filters.rooms.gte) {
      ret.numRooms = filters.rooms.gte;
    }
  }

  if (filters.photo) {
    ret.photo = filters.photo;
  }

  if (filters.garden) {
    ret.garden = filters.garden;
  }

  if (filters.balcony) {
    ret.balcony = filters.balcony;
  }

  if (filters.terrace) {
    ret.terrace = filters.terrace;
  }

  if (filters.publisher) {
    ret.sellerType = filters.publisher;
  }

  if (filters.publisherId) {
    ret.pId = filters.publisherId;
  }

  if (filters.mq) {
    if (filters.mq.gte) {
      ret.mqMin = filters.mq.gte;
    }

    if (filters.mq.lte) {
      ret.mqMax = filters.mq.lte;
    }
  }

  if (filters.bedrooms) {
    ret.bedrooms_min = filters.bedrooms.gte;
    ret.bedrooms_max = filters.bedrooms.lte;
  }

  if (filters.surface) {
    ret.srf_min = filters.surface.gte;
    ret.srf_max = filters.surface.lte;
  }

  if (filters.sortType) {
    ret.sortType = filters.sortType;
  }

  if (filters.page) {
    ret.page = filters.page;
  }

  return ret;
};

exports.apiParamsToQueryObject = apiParamsToQueryObject;